import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ── Meta (Facebook) Pixel — fires PageView on page load ──
const META_PIXEL_ID = '2209161729849733';
(function initMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  const n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  if (!document.getElementById('meta-pixel-script')) {
    const t = document.createElement('script');
    t.id = 'meta-pixel-script';
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const parent = document.head || document.documentElement;
    parent.appendChild(t);
  }
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
})();
render(<App data-id="element-316" />, document.getElementById('root'));